import axios from "../../../axios";

export const getSecrets = async () => {
    try {
        let { data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/vault`);
        return data;
    } catch (e) {
        console.log(e);
    }
};
